import { Action } from 'redux';

import {
  LoginActionConstants,
  LoginState,
  LoginAction,
  SetLoginArgs,
  SetLoginSessionArgs,
} from './types';

export const initialState: LoginState = {
  loginNetworkStates: {
    loginSessionRequest: {
      isRequesting: false,
    },
    loginRequest: {
      isRequesting: false,
    },
  },
  isInitialized: false,
};

export default function loginReducer(
  state = initialState,
  action: Action<LoginActionConstants>,
): LoginState {
  switch (action.type) {
    case LoginActionConstants.INITIALIZE: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case LoginActionConstants.LOGIN_SESSION_REQUEST:
      return {
        ...state,
        loginNetworkStates: {
          ...state.loginNetworkStates,
          loginSessionRequest: {
            ...state.loginNetworkStates.loginSessionRequest,
            isRequesting: true,
          },
        },
      };
    case LoginActionConstants.LOGIN_SESSION_SET: {
      const act = (action as LoginAction<SetLoginSessionArgs>);
      return {
        ...state,
        loginNetworkStates: {
          ...state.loginNetworkStates,
          loginSessionRequest: {
            isRequesting: false,
            lastError: act.error,
          },
        },
        loginStatus: act.result,
      };
    }
    case LoginActionConstants.LOGIN_REQUEST:
      return {
        ...state,
        loginNetworkStates: {
          ...state.loginNetworkStates,
          loginRequest: {
            ...state.loginNetworkStates.loginRequest,
            isRequesting: true,
          },
        },
      };
    case LoginActionConstants.LOGIN_SET: {
      const act = (action as LoginAction<SetLoginArgs>);
      return {
        ...state,
        loginNetworkStates: {
          ...state.loginNetworkStates,
          loginRequest: {
            isRequesting: false,
            lastError: act.error,
          },
        },
        loginStatus: act.result,
      };
    }
    default:
      return state;
  }
}
